/*
 * Copyright (c) 2025 curryfirm.com
 */

// errors.js

export class AppError extends Error {
    constructor(message, code = 'APP_ERROR', status = 500) {
        super(message);
        this.name = this.constructor.name;
        this.code = code;
        this.status = status;
        Error.captureStackTrace(this, this.constructor);
    }
}

// Specific error for validation issues
export class ValidationError extends AppError {
    constructor(message, field = null) {
        super(message, 'VALIDATION_ERROR', 400);
        this.field = field;
    }
}
